export const ASSET_CONSULTANTS = ['DVAG', 'Allfinanz', 'Allfinanz AG DVAG'];
